import {
  AuthApi,
  B2cApi,
  MediaApi,
  MeApi,
  NodeApi,
  NotificationApi,
  PetApi,
} from '@careforu-tailody/tailody-core-api';
import {
  AnomalyApi,
  ConditionApi,
  MetricsApi,
} from '@careforu-tailody/metrics-service-api';
import { getApiClient, getConfig } from '@api/index.ts';

export interface ApiInstances {
  auth: AuthApi;
  b2c: B2cApi;
  media: MediaApi;
  me: MeApi;
  node: NodeApi;
  notification: NotificationApi;
  pet: PetApi;
  anomaly: AnomalyApi;
  condition: ConditionApi;
  metrics: MetricsApi;
}

function createApiInstances(): ApiInstances {
  const axiosInstance = getApiClient().getAxiosInstance();
  const config = getConfig();

  return {
    auth: new AuthApi(undefined, config.baseUrl, axiosInstance),
    b2c: new B2cApi(undefined, config.baseUrl, axiosInstance),
    media: new MediaApi(undefined, config.baseUrl, axiosInstance),
    me: new MeApi(undefined, config.baseUrl, axiosInstance),
    node: new NodeApi(undefined, config.baseUrl, axiosInstance),
    notification: new NotificationApi(undefined, config.baseUrl, axiosInstance),
    pet: new PetApi(undefined, config.baseUrl, axiosInstance),
    anomaly: new AnomalyApi(undefined, config.baseUrl, axiosInstance),
    condition: new ConditionApi(undefined, config.baseUrl, axiosInstance),
    metrics: new MetricsApi(undefined, config.baseUrl, axiosInstance),
  };
}

let apiInstances: { apis: ApiInstances } | null = null;

export const apiClientManager = {
  get apis(): ApiInstances {
    if (!apiInstances) {
      apiInstances = { apis: createApiInstances() };
    }
    return apiInstances.apis;
  },
};
